import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';

import EmployeesFilter from '../EmployeesFilter';

export default function EmployeesCycleFilter() {
	const { t } = useTranslation();
	const { localize } = useLocalize();

	const query = graphql.useCycleTemplatesQuery({
		variables: {
			isArchived: false,
			first: 1000,
		},
	});

	return (
		<EmployeesFilter
			label={t('employees.filters.cycles.label')}
			name="cycleTemplateIDs"
			options={[
				..._.sortBy(
					query.data?.cycleTemplates.edges.map(({ node }) => ({
						label: localize(node.title).text,
						value: node.id,
					})) ?? [],
					'label',
				),
				{
					label: t('employees.filters.cycles.without'),
					value: '0',
				},
			]}
		/>
	);
}
